var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h24v24H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "scale(.04167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "b",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD0SURBVHgB1ZTNDcIwDIUfPwP0yDEb0BG6Ake2YANGQGzBDTFBRygblCO3doNiCyOkKnHSJIf2k57kxmkcxckDls4qcF5BOpH2Ej9JV9ILGShJHWkgNaRa4lZySRhZqJV4PM6FCyRwwXe3BvbinDsjgVrkgo/sruSxhk4P/Qh8eW8Bvi3cSGPJ8Vglc6Lh3XEjXU0ej0dRykLcUO5HI3GHgGu6gZ836SHxTr5vpCMyPbR5o3nR2H9cqL7kKsDNq/E3th5uKln8gMArazDtCv7mB/uS5j9akWBf8vmPC6sv+axiClZfylnAytYyxq92wHRi/5s5H9jAPDXSHkJ+AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user-2.a470d46d046140ca4773fac484736cdb.svg";
export { ForwardRef as ReactComponent };